import { CustomFieldDTO } from '../CustomFieldDTO';

export interface ReservationCustomFieldValueDTO {
  customFieldId: number;
  value: string;
  customFieldKey?: string;
  customFieldName?: string;
  customFieldType?: string;
}

export class ReservationDTO {
  id: number;
  serviceId: number;
  serviceName: string;
  centerId: number;
  centerName: string;
  resourceGroupId?: number;
  resourceGroupName?: string;
  resourceId?: number;
  resourceName?: string;
  /** IDs de recursos con la duración elegida (flujo por grupo). */
  resourceIdsForSelectedDuration?: number[];
  userId?: number;
  startTime: string;
  endTime: string;
  type: number;
  name: string;
  surname: string;
  phone: string;
  mail: string;
  numberDocumentation: string;
  acceptTractament: Date;
  observations?: string;
  documentType: number;
  startTimeDate: Date;
  endTimeDate: Date;
  codeIdentifier: string;
  rgpd?: string;
  /** Estado de pago devuelto por backend (`PENDING`/`PAID`/`ERROR`). */
  status?: string;
  /** Hold temporal para completar el pago de la reserva. */
  reservedUntil?: string;
  reservedToken?: string;
  /** Desglose de importes para reservas de pago. */
  basePrice?: number;
  ivaAmount?: number;
  feeAmount?: number;
  extrasAmount?: number;
  totalAmount?: number;
  /** Definición de campos personalizados (centro + servicio) para el formulario del paso 2 */
  customFields?: CustomFieldDTO[];
  /** Valores de campos personalizados de la reserva (enviados al backend) */
  customFieldValues?: ReservationCustomFieldValueDTO[];
  /** Origen (API). En creación lo persiste la API (portal sin rol de panel → PORTAL). Valor por defecto local. */
  createdFrom = 2;
  /** Permite cancelar la reserva según configuración del recurso/servicio. */
  reservationCancelable?: boolean;
}
